module.exports = __webpack_public_path__ + "static/media/afalp-BN.abb1927b.svg";